// extracted by mini-css-extract-plugin
export default {"container":"CompletionTitle_container__YeDSC","secondText":"CompletionTitle_secondText__kRAGb"};